import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";

import { changeDateTimeZoneFormat } from "../../services/core/CommonService";
import { agency_get_all_select } from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  sd_agency_id: Yup.object().required("Session Agency is required"),
  project_name: Yup.object().required("Project Name is required"),
  session_date: Yup.date().required("Session Date is required"),
  session_to_date: Yup.date().required("Session Two Date is required"),
  no_of_questions: Yup.number()
    .required("Number of Questions is required")
    .min(1, "At least 1 question is required")
    .max(50, "Maximum 50 questions allowed"),
  time_limit: Yup.number()
    .required("Time limit is required")
    .min(10, "Minimum time limit is 10 minutes")
    .max(60, "Maximum time limit is 60 minutes"),
  location: Yup.string()
    .max(55, "Venue cannot exceed 55 characters")
    .required("Venue is required"),
});
const SessionForm: React.FC<HeaderProps> = ({ dataIn, loadTableData }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: dataIn,
  });
  const { closeModal } = useSiteContext();
  const [allRole, setAllRole] = useState([]);

  const onSubmit = (data: any) => {
    let url = SESSION_URLS.INSERT;
    data["session_date"] = changeDateTimeZoneFormat(
      data.session_date,
      "DD-MM-YYYY",
    );

    data["session_to_date"] = changeDateTimeZoneFormat(
      data.session_to_date,
      "DD-MM-YYYY",
    );
    const subscription = post(url, data).subscribe((response) => {
      //console.log("response form ", response.data);
      closeModal();
      loadTableData();
    });
    return () => {
      subscription.unsubscribe();
    };
  };
  const sessionDate = watch("session_date");

  useEffect(() => {
    agency_get_all_select((data: any) => setAllRole(data));
  }, []);

  const elements: SdsFormElementProps[] = [
    {
      type: "SELECT_BOX",
      width: 6,
      name: "sd_agency_id",
      element: {
        label: "Session Agency",
        options: allRole,
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "project_name",
      element: {
        label: "Project Name",
        isRequired: true,
        inputType: "BORDER_LABEL",
        options: [
          { value: "WR", label: "WR" },
          { value: "NCR", label: "NCR" },
          { value: "WCR", label: "WCR" },
          { value: "SCR", label: "SCR" },
          { value: "ER", label: "ER" },

          { value: "CR-Bhusawal", label: "CR-Bhusawal" },
          { value: "CR-Nagpur", label: "CR-Nagpur" },
          { value: "CR-Solapur", label: "CR-Solapur" },
          { value: "CR-Mumbai", label: "CR-Mumbai" },
          { value: "CR-Pune", label: "CR-Pune" },

          { value: "WR-Ratlam", label: "WR-Ratlam" },
          { value: "WR-Ahmedabad", label: "WR-Ahmedabad" },
          { value: "WR-Rajkot", label: "WR-Rajkot" },
        ],
      },
    },
    {
      type: "DATE",
      width: 6,
      name: "session_date",
      element: {
        label: "Session Date",
        isRequired: true,
        placeHolder: "Select Date",
        minDate: new Date(new Date().setDate(new Date().getDate() - 1))
          .toISOString()
          .split("T")[0],
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "DATE",
      width: 6,
      name: "session_to_date",
      element: {
        label: "Session Day Two Date",
        isRequired: true,
        placeHolder: "Select Date",
        minDate: sessionDate || new Date(new Date().setDate(new Date().getDate() - 1))
          .toISOString()
          .split("T")[0],
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "TEXT_BOX",
      width: 6,
      name: "time_limit",

      element: {
        label: "Time Allowed in Minutes",
        isRequired: true,
        max: 10,
        type: "number",
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "time_limit_two",

      element: {
        label: "Day Two Time Allowed in Minutes",
        isRequired: true,
        max: 10,
        type: "number",
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "no_of_questions",

      element: {
        label: "No. Of Questions",
        isRequired: true,
        max: 10,
        type: "number",
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "location",

      element: {
        label: "Enter Venue:",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="mt-0">
        <div
          className="sd-hims-input ml-6 mr-6 mb-6 p-5"
          style={{ overflow: "visible", position: "relative", zIndex: 1050 }}
        >
          <SdsForm elements={elements} errors={errors} control={control} />
        </div>
      </div>
    </>
  );
};

export default SessionForm;
